module.exports = __webpack_public_path__ + "static/media/teamwork.f9cf18d3.svg";